<template>
  <div>
    <el-col :span="6" v-for="item in result.data" :key="item.artiId" class="yi-cun-section-wrap">
      <div class="yi-cun-section">
        <a
          style="text-decoration:none;color:#000;"
          v-bind:href="'/portal/arti/detail/article/zzsl_detail/' + item.artiId"
        >
          <div style="height:100px;">
            <img :src="item.imgUrl||$app.nodata.img" :alt="item.artiName" class="img-fluid" />
          </div>
          <h5 class="title" v-text="item.artiName"></h5>
        </a>
      </div>
      <div class="bottom">&nbsp;</div>
    </el-col>
  </div>
</template>
<script>
require("../../styles/portal/culture.scss");
export default {
  data() {
    return {
      routeType: "arti"
    };
  },
  mounted() {},
  props: {
    routeWatch: {
      type: Boolean,
      default: true
    },
    result: {
      type: Object
    }
  },
  components: {},
  methods: {},
  created() {
    //this.$menuFn.setTitle("portal-from-detail");
  },
  watch: {}
};
</script>
<style lange="sass" scoped>
</style>